import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import s from './style.css';
import { Button } from '../../components';
import { auth } from '../../actions';
import { globalData } from '../../actions/globalVariables';
const CodeForm = (props) => {
    const [timer, setTimer] = useState(60);
    const [input, setInput] = useState('');
    const currentTime = new Date().getTime();
    const pinInputs = Array.from({ length: 6 }, () => React.createRef());
    const handleInput = (event, index) => {
        const { value } = event.target;
        if (value.length > 1) {
            pinInputs[index].current.value = value[value.length - 1];
        }
        if (index < pinInputs.length - 1 && value !== '') {
            pinInputs[index + 1].current.focus();
        }
        setInput(pinInputs.map((ref, idx) => (idx === index ? value[value.length - 1] : ref.current.value)).join(''));
    };
    const handleKeyDown = (event, index) => {
        const target = event.target;
        const { key } = event;
        const { value } = target;
        if (key === 'Backspace' && index > 0 && pinInputs[index].current.value === '') {
            pinInputs[index - 1].current.focus();
        }
        setInput(pinInputs.map((ref, idx) => (idx === index ? value[value.length - 1] : ref.current.value)).join(''));
    };
    let timerCounter;
    const timing = (currentTime) => {
        setTimer(60 - (new Date().getTime() - currentTime) / 1000);
        if (timer <= 0) {
            clearInterval(timerCounter);
        }
    };
    useEffect(() => {
        pinInputs[0].current.focus();
        timerCounter = setInterval(() => timing(currentTime), 1000);
        return () => {
            clearInterval(timerCounter);
        };
    }, []);
    useEffect(() => {
        if (input.length === 6) {
            props.verifyEmailCode(input, props.email, () => props.setForm('password'), () => {
                pinInputs.forEach((ref) => (ref.current.value = ''));
                pinInputs[0].current.focus();
                setInput('');
            });
        }
    }, [input.length === 6]);
    const resend = () => {
        props.requestEmailCode(globalData.authId, () => props.setForm('code'), () => props.setForm('qr'));
    };
    return (React.createElement("div", { className: s.formContainer },
        React.createElement("p", { className: s.description },
            "Enter the verification code sent to ",
            '\n',
            React.createElement("b", null, globalData.authId)),
        React.createElement("div", { className: s.pinContainer }, pinInputs.map((ref, index) => (React.createElement("input", { key: index, type: 'number', maxLength: 1, className: s.pinInput, ref: ref, onInput: (e) => handleInput(e, index), onKeyDown: (e) => handleKeyDown(e, index) })))),
        React.createElement(Button, { text: 'Continue', id: 'continue' }),
        React.createElement("button", { type: 'button', className: s.resend, style: { textDecorationLine: 'underline' }, onClick: resend },
            React.createElement("p", null, "Resend Code"))));
};
const mapStateToProps = (state) => ({
    country: state.appTemp.country,
    phone: state.app.phone,
    email: state.app.email,
});
const connector = connect(mapStateToProps, { ...auth });
export default connector(CodeForm);
